<template>
  <div class="router-view">
    <RouterView />
    <ToastsBar />
    <ModalGame :game-id="selectedGameToView" @close="selectGameToView(null)" />
    <div v-if="data.sharing?.type === 'admin'" class="impersonate">
      The current user <strong>{{ data.currentUser?.email }}</strong> is being
      impersonated by
      {{ data.sharing?.user?.email }}
      <ButtonSecondary label="Turn off" @click="endImpersonation()" />
    </div>
  </div>
</template>

<script setup lang="ts">
import ToastsBar from '~/common/ToastsBar.vue';
import { injectStrict } from '~/common/inject';
import { AppDataInjectionKey } from '~/common/useAppData';
import { useI18n } from 'vue-i18n';
import ModalGame from '~/cockpit/games/components/ModalGame.vue';
import { useGameDetailModal } from '~/cockpit/games/useGameDetailModal';
import ButtonSecondary from '~/common/buttons/ButtonSecondary.vue';
import useApi from '~/common/useApi';

const { locale, data } = injectStrict(AppDataInjectionKey);

const i18n = useI18n();

i18n.locale.value = locale.value;

const { selectedGameToView, selectGameToView } = useGameDetailModal();

const api = useApi('admin/api/impersonate/end', {
  baseUrl: '/',
});
async function endImpersonation() {
  await api.post();
  window.location.href = '/admin';
}
</script>

<style lang="scss">
.router-view {
  .impersonate {
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 12px;
    padding: 0.5rem;
    background: hsl(48, 100%, 50%);
  }
}
</style>
